import CloudinariesPage from "./cloudinary-reports-page";


const CloudinaryPages = {
    Archive : CloudinariesPage
}

export default CloudinaryPages;